import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { ASPECT_RATIO } from "@/react/components/constants";
import { ImageUploadInput } from "@/react/components/shared/ImageUploadInput";
import { Form } from "@/react/components/shared/uikit/Form";
import { Typography } from "@/react/components/shared/uikit/Typography";
import type { BrandingSettings } from "../PlusLiteDashboard";

export const BrandingSettingsFormContent = () => {
  const i18nRoot = "settings.mobile_app.design_section";
  const { watch } = useFormContext<BrandingSettings>();

  const brandColorLight = watch("brand_color_light_mode");
  const brandColorDark = watch("brand_color_dark_mode");
  const buttonTextColorLight = watch("button_text_color_light");
  const buttonTextColorDark = watch("button_text_color_dark");

  return (
    <div className="bg-tertiary mt-2 rounded-lg px-6 py-5">
      <div className="space-y-6">
        <Form.Item
          name="brand_color_light_mode"
          label={t([i18nRoot, "brand_color_light"])}
          hideDescription
          className="flex !items-center justify-between !border-none"
          inline
        >
          <Typography.LabelSm weight="semibold" color="text-dark">
            {typeof brandColorLight === "string" && brandColorLight
              ? brandColorLight.toUpperCase()
              : ""}
          </Typography.LabelSm>
          <Form.ColorPickerV2 name="brand_color_light_mode" />
        </Form.Item>

        <Form.Item
          name="brand_color_dark_mode"
          inline
          label={t([i18nRoot, "brand_color_dark"])}
          className="flex !items-center justify-between !border-none"
          hideDescription
        >
          <Typography.LabelSm weight="semibold" color="text-dark">
            {typeof brandColorDark === "string" && brandColorDark
              ? brandColorDark.toUpperCase()
              : ""}
          </Typography.LabelSm>
          <Form.ColorPickerV2 name="brand_color_dark_mode" />
        </Form.Item>

        <Form.Item
          name="button_text_color_light"
          label={t([i18nRoot, "button_text_color_light"])}
          hideDescription
          className="flex !items-center justify-between !border-none"
          inline
        >
          <Typography.LabelSm weight="semibold" color="text-dark">
            {typeof buttonTextColorLight === "string" && buttonTextColorLight
              ? buttonTextColorLight.toUpperCase()
              : ""}
          </Typography.LabelSm>
          <Form.ColorPickerV2 name="button_text_color_light" />
        </Form.Item>

        <Form.Item
          name="button_text_color_dark"
          inline
          label={t([i18nRoot, "button_text_color_dark"])}
          className="flex !items-center justify-between !border-none"
          hideDescription
        >
          <Typography.LabelSm weight="semibold" color="text-dark">
            {typeof buttonTextColorDark === "string" && buttonTextColorDark
              ? buttonTextColorDark.toUpperCase()
              : ""}
          </Typography.LabelSm>
          <Form.ColorPickerV2 name="button_text_color_dark" />
        </Form.Item>

        <ImageUploadInput
          name="logo_light"
          isHorizontal
          className="py-2"
          isCropEnabled={false}
          label={t([i18nRoot, "logo_light"])}
          title={t([i18nRoot, "logo_light"])}
          description={t([i18nRoot, "logo_light_description"])}
          aspectRatio={ASPECT_RATIO.COMMUNITY_LOGO_V3}
        />

        <ImageUploadInput
          name="logo_dark"
          isHorizontal
          className="py-2"
          isCropEnabled={false}
          label={t([i18nRoot, "logo_dark"])}
          title={t([i18nRoot, "logo_dark"])}
          description={t([i18nRoot, "logo_dark_description"])}
          aspectRatio={ASPECT_RATIO.COMMUNITY_LOGO_V3}
        />
      </div>
    </div>
  );
};
